module.exports = __webpack_public_path__ + "img/ybfw.eb462e62.svg";